import React from "react";

import { Box, Text, TextProps } from "@chakra-ui/react";

import {
  ParsedComment,
  ParsedCommentSegment
} from "@/jenesys-types/data/communication";
import { User } from "@/jenesys-types/jenesys-entities/config";

import { MentionBadge } from "./MentionBadge";

interface ParsedCommentRendererProps {
  parsedComment: ParsedComment;
  companyMembers: User[];
  size?: TextProps["fontSize"];
}

export const ParsedCommentRenderer: React.FC<ParsedCommentRendererProps> = ({
  parsedComment,
  companyMembers,
  size = "sm"
}) => {
  const userMap = new Map<string, User>();
  companyMembers.forEach((member) => {
    userMap.set(member.id, member);
  });

  const renderSegment = (segment: ParsedCommentSegment, index: number) => {
    if (segment.type === "mention" && segment.userId) {
      const user = userMap.get(segment.userId);
      if (user) {
        return <MentionBadge key={index} user={user} size={size} />;
      }
    }

    return (
      <Text key={index} as="span" fontSize={size} whiteSpace="pre-line">
        {segment.content}
      </Text>
    );
  };

  return (
    <Box>
      {parsedComment.segments.map((segment, index) =>
        renderSegment(segment, index)
      )}
    </Box>
  );
};
